module.exports = __webpack_public_path__ + "7948839b45862c2508268f8efa34e508.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/booking_holdings_2023_chart.png
// module id = 1638
// module chunks = 0